import { useEffect } from 'react';

function loadCSS(cssURL: string) {
  const links = Array.from(document.getElementsByTagName('link'));
  // Don't add the CSS link twice
  if (links.some(l => l.rel === 'stylesheet' && l.href === cssURL)) {
    return;
  }
  const stylesheet = document.createElement('link');
  stylesheet.rel = 'stylesheet';
  stylesheet.href = cssURL;
  document.head.appendChild(stylesheet);
}

const useZapierElements = () => {
  useEffect(() => {
    let cdnHost = 'cdn.zapier.com';
    try {
      const zapierLocationMatch = location.host.match(
        /.+(zapier(-staging)?\.com)/
      );
      if (zapierLocationMatch) {
        cdnHost = `cdn.${zapierLocationMatch[1]}`;
      }
      if (location.hostname === 'localhost') {
        cdnHost = 'cdn.zapier-staging.com';
      }
    } catch (_) {
      // If something goes wrong, use the default
    }
    const script = document.createElement('script');
    script.type = 'module';
    script.src = `https://${cdnHost}/packages/partner-sdk/v0/zapier-elements/zapier-elements.esm.js`;
    document.head.appendChild(script);

    const cssURL = `https://${cdnHost}/packages/partner-sdk/v0/zapier-elements/zapier-elements.css`;
    loadCSS(cssURL);
  }, []);
};

export default useZapierElements;
